import React, { useEffect, useRef, useState } from "react";
import { ArrowButton } from "../../molecules/ArrowButton";

import "primeicons/primeicons.css";
import { BigImgBox } from "molecules/BigImgBox";
import { SectionBorder } from "molecules/SectionBorder";

import Divider from "molecules/SimpleBorder/Divider";

/** Accepts watch, embed, Shorts, or youtu.be URLs; returns embed URL or null */
function youtubeUrlToEmbedUrl(url) {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  const m =
    s.match(
      /(?:youtube\.com\/watch\?[^#]*v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    ) || s.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export const TextVideoSection = (props) => {
  const data = props.data;
  const embedUrl = youtubeUrlToEmbedUrl(data?.right_side_youtube_url);
  console.log(data, "vid");
  const [isVisible, setIsVisible] = useState(false);
  const borderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after visibility
        }
      },
      { threshold: 0.1 } // Trigger when 10% is visible
    );

    if (borderRef.current) {
      observer.observe(borderRef.current);
    }

    return () => {
      if (borderRef.current) {
        observer.unobserve(borderRef.current);
      }
    };
  }, []);

  return (
    <div className="container pl-0  pr-0">
      <section className=" section-padding1 px-0 pt-0 ">
        <div
          className="container borderSpacing pl-0 pr-0"
          style={{ marginBottom: "42.75px" }}
        >
          <SectionBorder />
        </div>
        <style>
          {`
          @keyframes widthIncrease {
            from {
              width: 10%;
            }
            to {
              width: 100%;
            }
          }

          .animated-border {
            height: 1px; /* Adjust height as needed */
            background-color: black; /* Change this if you want a different color */
            transition: width 0.5s; /* Optional: smooth transition */
          }

          .animated {
            animation: widthIncrease 2s forwards; /* Adjust duration as needed */
          }
        `}
        </style>

        <div className="container pl-0  pr-0  ">
          <div className="mainHr1" style={{ backgroundColor: "transparent" }} />
          {/* <Divider/> */}
          <div className="grid " style={{ borderColor: "black" }}>
            <div className="lg:col-4 md:col-4 sm:col-12  align-items-center text-2xl p-0">
              <h2
                className="section-title "
                style={{ marginTop: "-10px" }}
                dangerouslySetInnerHTML={{
                  __html: data?.left_side_heading_text,
                }}
              >
                {/* Real assets;
              <br />
              advised, monitored
              <br /> and managed */}

                {/* {data?.left_side_heading_text} */}
              </h2>
            </div>
            <div
              className="lg:col-8 md:col-6 sm:col-12   font-medium text-justify pt-0 pr-0 pl-1"
              style={{ fontSize: "18px !important", wordSpacing: "0px" }}
            >
              <div className="" style={{ width: "100%" }}>
                {/* <p className="details-text mb-4 " data-aos="fade-up">
                Quantum Projectinfra Pvt Ltd (Quantum) is a Real Estate Advisor
                and Manager for End to End Asset Management. Quantum provides
                services on PAN India basis through its local office presence in
                all major cities.
              </p> */}
                <p
                  className="details-text"
                  data-aos="fade-up"
                  dangerouslySetInnerHTML={{
                    __html: data?.right_side_main_text,
                  }}
                >
                  {/* Quantum is driven by its Vision statement: “To elevate the
                professional standards of the Indian realty sector by creating
                projects that deliver the best value and experience” Quantum
                imbibes Core Values of “Integrity, Excellence, Team and Trust” */}
                  {/* {data?.right_side_main_text} */}
                </p>

                <ArrowButton
                  width="170"
                  buttonText={data?.right_side_hyperlink_text}
                  // buttonText="View all services"
                  bgColor="#CDC08B"
                  textColor="#000000"
                  url={data?.right_side_hyperlink_link}
                />
              </div>
              <div
                ref={borderRef}
                className={` mt-4 mb-4   animated-border ${
                  isVisible ? "animated" : ""
                }`}
                style={{ width: isVisible ? "98%" : "10%" }} // Initial width based on visibility
              ></div>
              <div
                className="pr-1  communityImage"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "0",
                  paddingBottom: "56.25%",
                }}
              >
                {embedUrl ? (
                  <iframe
                    src={`${embedUrl}?rel=0`}
                    title="Featured video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    className="img-fluid"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                    }}
                  />
                ) : (
                  <img
                    src={`${
                      data?.right_side_image
                        ? "" + data?.right_side_image
                        : "media/about_banner.png"
                    }`}
                    alt=""
                    className="img-fluid"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
              {/* <BigImgBox imgpath="media/home_about_banner.png" /> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
